import React from "react";
import AppView from "../../components/Layout/AppView";

const CampaignsPage = () => {
  return <AppView>Campaigns Page</AppView>;
};

export default CampaignsPage;
